export default __webpack_public_path__ + "static/media/img3.92887ed3.webp";